import React, { Component } from 'react';
import { selectors, actions } from '../sagas/customers'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Row from './Row'
import NoCustomers from './NoCustomers'

class CustomerTable extends Component {

  render () {
    return (
      <div className={'table-row-wrapper'}>
        { this.props.customers &&
          this.props.customers.length > 0 &&
          this.props.customers.map( customer => {
            return(
              <Row customer={customer}/>
            )
          })
        }
      </div>
    );
  }

};

const mapStateToProps = (store) => ({
  customers: selectors.customers(store)
})

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

export default (connect(mapStateToProps, mapDispatchToProps)(CustomerTable))



// WEBPACK FOOTER //
// ./src/Customers/CustomerTable.jsx